import { render, staticRenderFns } from "./MedecinDetailFpostgradcreate.vue?vue&type=template&id=6a6a4118&"
import script from "./MedecinDetailFpostgradcreate.vue?vue&type=script&lang=js&"
export * from "./MedecinDetailFpostgradcreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports